




































import Vue from "vue";
import Component from "vue-class-component";
import { MedicalInvoice } from "@/components/medicalEdit/types";
import { Prop, Emit } from "vue-property-decorator";
import { PulldownItem } from "@/types";
import InvoiceOutBurden from "@/components/medicalEdit/invoice/part/InvoiceOutBurden.vue";

@Component({
  components: {
    InvoiceOutBurden
  }
})
export default class InvoiceOutBurdens extends Vue {
  @Prop() tab!: MedicalInvoice;

  @Prop() tax_rate_items!: PulldownItem[];

  @Emit("addInsOut")
  addInsOut() {
    return;
  }

  @Emit("deleteInsOut")
  deleteInsOut(index: number) {
    return index;
  }

  @Emit("updateTotalOuts")
  updateTotalOuts() {
    return;
  }
}
